module.exports = __webpack_public_path__ + "img/clear-day.4a8b45a1.svg";